/**
 * @description
 * @author Kody
 * @date 2018-07-03
 */

import Api from '../../../../path';
import { fetchData } from '@umu/umu-fetch';
import IInput from './models/input';
import IOutput from './models/output';
export const listenerInfoFetch = (data: IInput): Promise<IOutput> => {
    return fetchData(Api.LISTENER_INFO_FETCH, data).then((res: IOutput) => {
        return res.data;
    });
};
